angular.module('harriApp')
    .controller('ScreeningController', [
        '$scope', '$state', '$stateParams', 'hUser',
        function ($scope, $state, $stateParams, hUser) {

            $scope.loading = true;

            const init = async () => {

                $scope.isEmployer = hUser.isEmployer();

                ProfileAPI.getBrandProfile($stateParams.brand_id).then(function (brand) {
                    $scope.brand = brand;
                    $scope.$digest();
                });

                if ($stateParams.form_type === 'EQUAL_EMPLOYMENT_OPPORTUNITY') {
                    const params = {
                        job_ids: $stateParams.job_id
                    };
                    const formData = await EEOAPI.getEeoQuestionsCandidateSettings($stateParams.brand_id, 'EQUAL_EMPLOYMENT_OPPORTUNITY', params);
                    formData.type = $stateParams.form_type;

                    const eeoStandardFormsQuestions = formData.forms.filter(form => form.is_standard).flatMap(form => form.questions);
                    const eeoCustomFormsQuestions = formData.forms.filter(form => !form.is_standard).flatMap(form => form.questions);
                    formData.questions = [...eeoStandardFormsQuestions, ...eeoCustomFormsQuestions];

                    $scope.eeoQuestionsCandidateForm = new EEOQuestionsCandidateForm(
                        $scope,
                        $stateParams.brand_id,
                        $stateParams.job_id
                    );

                    $scope.eeoQuestionsCandidateForm.load(formData);

                    $scope.screeningForm = formData;
                    $scope.loading = false;
                } else {
                    try {
                        const screeningForm = await AQAAFAPI.getScreeningForms(
                            $stateParams.brand_id,
                            $stateParams.job_id,
                            $stateParams.screening_forms_id,
                            $stateParams.form_type
                        );

                        $scope.screeningAnswerForm = new ScreeningAnswerForm(
                            $scope,
                            screeningForm,
                            $stateParams.application_id,
                            $stateParams.job_id,
                            $stateParams.form_type
                        );

                        $scope.screeningForm = screeningForm;
                    } catch (err) {
                        if (err) {
                            switch (err.data) {
                                case "FORM_ALREADY_ANSWERED":
                                    $scope.alreadyAnswered = true;
                                    break;
                                case"NO_ACTIVE_JOB_APPLICATION_FOUND_FOR_THIS_USER":
                                    $scope.invalidUser = true;
                                    break;
                                case "USER_IS_NOT_ALLOWED_TO_ACCESS_THIS_STAGE":
                                    $scope.userNotAllowedToAccess = true;
                                    break;
                                case "INVALID_JOB_SCREENING_FORM_ID":
                                    $scope.invalidForm = true;
                                    break;
                                default:
                                    console.error(err);
                            }
                        } else {
                            console.error(err);
                        }
                    } finally {
                        $scope.loading = false;
                        $scope.$digest();
                    }
                }
            };

            init();

            $scope.goToDashboard = function () {
                $state.go("appLayout.harriSH.dashboard");
            };

            $scope.optOut = async () => {
                $scope.submittingForm = true;
                try {
                    await $scope.eeoQuestionsCandidateForm.optOutEEOForm();
                    $state.go("appLayout.harriSH.dashboard");
                } catch (e) {
                    console.error(e)
                }
                $scope.submittingForm = false;
            };

            $scope.submitAnswers = () => {
                $scope.submittingForm = true;
                if ($stateParams.form_type === 'EQUAL_EMPLOYMENT_OPPORTUNITY') {
                    $scope.eeoQuestionsCandidateForm.validator.validate(async (isValid) => {
                        if (isValid) {
                            try {
                                const response = await $scope.eeoQuestionsCandidateForm.save();
                                if (response?.data && response?.status_code === 200) {
                                    $scope.submitting_complete = true;
                                    $scope.$digest();
                                } else {
                                    console.error(response?.data);
                                }
                            } catch (e) {
                                console.error(e);
                            }
                        }
                        $scope.submittingForm = false;
                    });
                } else {
                    $scope.screeningAnswerForm.validator.validate(async (isValid) => {
                        if (isValid) {
                            try {
                                const response = await $scope.screeningAnswerForm.save();
                                if (response?.data?.data && response?.data?.status_code === 200) {
                                    $scope.submitting_complete = true;
                                    $scope.$digest();
                                } else {
                                    console.error(response?.data);
                                }
                            } catch (e) {
                                console.error(e)
                            }
                        }
                        $scope.submittingForm = false;
                    });
                }
            };
        }]);